import { api } from './client';

// 플랫폼 데이터 타입
export interface PlatformSummary {
  roomtypeName: string;
  reservableQuantity: number;
  saleOpen: boolean;
  rulesetId?: number;
}

export interface PlatformInventory {
  roomtypeName: string;
  rulesetName: string;
  rulesetId: number;
  reservableQuantity: number;
  bookingRate: number;
  saleOpen: boolean;
}

export interface PlatformData {
  data: {
    allSummaries?: PlatformSummary[];
    inventorySummaries?: PlatformInventory[];
  };
}

export interface PlatformUpdate {
  rulesetId: number;
  count?: number;       // 수량 수정 시
  bookingRate?: number; // 가격 수정 시
}

export const platformApi = {
  // 야놀자 데이터 조회
  getYanoljaData: async (date: string): Promise<PlatformData> => {
    const response = await api.get(`/proxy/platform/yanolja/${date}`);
    return response.data.data;
  },

  // 여기어때 데이터 조회
  getYeogiData: async (date: string): Promise<PlatformData> => {
    const response = await api.get(`/proxy/platform/yeogi/${date}`);
    return response.data.data;
  },

  // 야놀자 수량/가격 수정
  updateYanolja: async (date: string, updates: PlatformUpdate[]): Promise<any> => {
    const response = await api.post('/proxy/platform/yanolja/update', { date, updates });
    return response.data.data;
  },

  // 여기어때 수량/가격 수정
  updateYeogi: async (date: string, updates: PlatformUpdate[]): Promise<any> => {
    const response = await api.post('/proxy/platform/yeogi/update', { date, updates });
    return response.data.data;
  },
};
